import {useState, useEffect} from "react";
import {notification} from "antd";
export default function useDevices() {
  const [devices, setDevices] = useState([]);
  useEffect(() => {
    const getDevices = () => navigator.mediaDevices.enumerateDevices().then((newDevices) => setDevices(newDevices.filter(({deviceId}) => !!deviceId))).catch(handleError);
    navigator.mediaDevices.addEventListener("devicechange", getDevices);
    navigator.mediaDevices.getUserMedia({audio: true, video: true}).then(() => getDevices());
    return () => {
      navigator.mediaDevices.removeEventListener("devicechange", getDevices);
    };
  }, []);
  const handleError = (error) => {
    notification.error({message: "Error", description: error.message || "Oops! Something went wrong!"});
  };
  return {
    audioInputDevices: devices.filter((device) => device.kind === "audioinput"),
    videoInputDevices: devices.filter((device) => device.kind === "videoinput"),
    audioOutputDevices: devices.filter((device) => device.kind === "audiooutput")
  };
}
